import { fetchUrgentOfferRoomDates } from 'actions/RecommendationActions'
import type { UrgentRoomDateData } from 'components/OfferPage/types'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'

export function useUrgentOfferRoomDateData(offerId: string, roomTypeId: string | undefined) {
  const dispatch = useAppDispatch()
  const offerSharedState = useAppSelector(state => state.recommendations.offerSharedState[offerId])
  const urgentRoomDatesCacheKey = useMemo(() => {
    const hasValidDates = offerSharedState?.checkIn && offerSharedState?.checkOut
    return hasValidDates && !!roomTypeId
      ? `${offerId}_${roomTypeId}_${offerSharedState.checkIn}_${offerSharedState.checkOut}`
      : null
  }, [offerId, roomTypeId, offerSharedState?.checkIn, offerSharedState?.checkOut])

  const cachedRoomDateData: UrgentRoomDateData | undefined = useAppSelector(state =>
    urgentRoomDatesCacheKey ? state.recommendations.urgentOfferRoomDates.data[urgentRoomDatesCacheKey] : undefined,
  )

  useEffect(() => {
    if (urgentRoomDatesCacheKey && offerSharedState?.checkIn && offerSharedState?.checkOut) {
      dispatch(
        fetchUrgentOfferRoomDates(offerId, roomTypeId as string, offerSharedState.checkIn, offerSharedState.checkOut),
      )
    }
  }, [offerId, roomTypeId, urgentRoomDatesCacheKey, offerSharedState?.checkIn, offerSharedState?.checkOut, dispatch])

  return cachedRoomDateData
}
